import { render, staticRenderFns } from "./KeyFinanceRatio.vue?vue&type=template&id=4b15a37c&scoped=true"
import script from "./KeyFinanceRatio.vue?vue&type=script&lang=js"
export * from "./KeyFinanceRatio.vue?vue&type=script&lang=js"
import style0 from "./KeyFinanceRatio.vue?vue&type=style&index=0&id=4b15a37c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b15a37c",
  null
  
)

export default component.exports